export const makeSession = () => {
    let current = null;
    return {
        session: { user: () => current },
        set: (u) => {
            current = u;
        },
    };
};
//# sourceMappingURL=session.js.map